import request from '../util/request'

// 发送通知
export function sendNotice(data) {
  return request({
    url: 'pr/notices',
    method: 'post',
    data
  })
}
// 根据问卷id查询通知列表
export function getNotices(params) {
  return request({
    url: 'pr/notices',
    method: 'get',
    params
  })
}
// 根据id删除通知
export function deleteNotice(id) {
  return request({
    url: `pr/notices/${id}`,
    method: 'delete'
  })
}
// 根据通知id修改通知
export function modifyNotice(id, data) {
  return request({
    url: `pr/notices/${id}`,
    method: 'put',
    data
  })
}